/*!
 * beForm Jquery plugin:
 * Jquery plugin para el envio de formularios via AJAX
 * Author: @pablocrs
 */

;(function ( $, window, document, undefined ) {


    // Create the defaults once
    var pluginName = 'beForm',
        defaults = {
            repopulate: false,
            loadingContainer: '.o-form__loading',
            apiUrl: window.location.origin,
            submitOnChange: false,
            type: 'POST'
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend( {}, defaults, options) ;

        this._defaults = defaults;
        this._name = pluginName;

        this.formData = {};

        if(this.$element.data('on-change')){
            this.options.submitOnChange = true;
        }

        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;

        Plugin.options.submitUrl = Plugin.$element.attr('action');
        Plugin.options.type = Plugin.$element.attr('type');

        Plugin.submitButton = Plugin.$element.find('[type="submit"]');


        Plugin.getLocale();

        Plugin.$element.on('submit',function(e){
            return false;
        });

        Plugin.$element.find('button.btn').each(function(){
            $(this).on('click',function(e){
                Plugin.submitValue = [];
                Plugin.submitValue['name'] = $(this).attr('name');
                Plugin.submitValue['value'] = $(this).val();
                Plugin.sendForm(e);
            });
        })

        if(Plugin.options.submitOnChange){
            Plugin.$element.find('input,select,textarea').on('change',function(e){
                Plugin.sendForm(e);
            })
        }
    };

    /// Acciones para el envío del formulario
    //
    Plugin.prototype.sendForm = function(e){
        var Plugin = this;
        e.preventDefault();

        if(Plugin.validateFormValues() === true){
            Plugin.parseFormValues();
            Plugin.submitForm();
        }
        else{
            return false;
        }
    };

    /// Recoge el locale activo
    //
    Plugin.prototype.getLocale = function(){
        var Plugin = this;

        var localePath = $(location).attr('pathname');

        localePath.indexOf(1);
        localePath.toLowerCase();
        localePath = localePath.split("/")[1];

        if(localePath === 'en'){
            Plugin.options.apiUrl = window.location.origin + '/' + localePath;
        }
    };

    /// Serializa los inputs para enviar en body
    //
  Plugin.prototype.parseFormValues = function () {
    var Plugin = this;

    Plugin.formData = new FormData();
    var serializedForm = Plugin.$element.serializeArray();
    $.each(serializedForm, function (key, value) {
      Plugin.formData.append(value.name, value.value)
    });

    var serializedCheckboxes = Plugin.$element.find('input:checkbox').map(function () {
      return {name: this.name, value: this.checked ? this.value : "0"};
    });

    // Mergeo los checkboxes sin checkear con el resto de valores
    $.each(serializedCheckboxes, function (checkboxKey, checkboxValue) {
      var found = false;
      $.each(Plugin.formData, function (formDataKey, formDataValue) {
        Plugin.formData.append(formDataValue.name, formDataValue.value);
      });

      if (!found) {
        Plugin.formData.append(checkboxValue.name, checkboxValue.value);
      }
    });

    var serializedFiles = Plugin.$element.find('.js-beForm_fileUp');
    $.each(serializedFiles, function (fileKey, fileValue) {
      if (fileValue.files.length !== 0 && fileValue.files[0].size !== 0) {
        Plugin.formData.append('file', fileValue.files[0]);
      }
    });
    Plugin.formData.append(Plugin.submitValue['name'], Plugin.submitValue['value']);
  };

    /// Validacion del formulario
    //
    Plugin.prototype.validateFormValues = function(){
        var Plugin = this;

        return true
    };

    /// Activa y desactiva el modo cargando
    //
    Plugin.prototype.toggleLoading = function(bool){
        var Plugin = this;

        $.get(window.location.origin + '/loading-icon').success(function(data){
            if(bool == true){
                Plugin.$element.find('.o-form__loading').toggleClass('hide').html(data);
                Plugin.submitButton.attr('disabled',true);
            }
            else{
                Plugin.$element.find('.o-form__loading').toggleClass('hide').html('');
                Plugin.submitButton.attr('disabled',false);
            }
        });
    };

    /// Envío del formulario AJAX
    Plugin.prototype.submitForm = function(){
        var Plugin = this;

        Plugin.toggleLoading(true);

        $.ajax({
            url : Plugin.options.submitUrl,
            type: 'POST',
            data: Plugin.formData,
            processData: false,
            contentType: false,
            success: function (data) {
                Plugin.toggleLoading(false);
                Plugin.removeAlerts();
                Plugin.throwAlerts(data);
                if(data.redirect){
                    window.location.href = data.redirect;
                }
                $(Plugin.element).trigger('bw.Success', data);
            },
            error: function (data) {
                Plugin.toggleLoading(false);
                Plugin.removeAlerts();
                Plugin.throwAlerts(data);
                $(Plugin.element).trigger('bw.Error', data);
            }
        });
    };

    /// Lanzadera de alertas
    //
    Plugin.prototype.removeAlerts = function(){
        $(document).find('.has-error').toggleClass('has-error');
    };

    Plugin.prototype.throwAlerts = function(data){
        var Plugin = this;

        var response = '';

        if(data.responseText){
            response = jQuery.parseJSON(data.responseText);
            if(response.msg && response.msg.ValidationErrors) {
                $.each(response.msg.ValidationErrors, function (index, value) {
                  var indexChecked = index;

                  if (index.includes('\.')) {
                    indexChecked = index.replace(/\./g, '\\.');
                  }

                  var indexSelector  =  $('[name=' +  indexChecked + '],[data-name=' +  indexChecked + ']');

                  indexSelector.parent().addClass('has-error');
                  indexSelector.find('.select2-selection').toggleClass('has-error');
                });
            }
        }
        else{
            response = data;
        }


        $.ajax({
            url: Plugin.options.apiUrl + '/alert-template',
            type: 'POST',
            data: {
                msg : response.msg,
                status : response.status
            },
            success: function(data){
                var msg = Plugin.$element.find('.o-form__msg').html(data);
            },
            error: function(data){
                var msg = Plugin.$element.find('.o-form__msg').html(data);
            }
        });
    };

    /// TODO: LLENAR FOMULARIO CON DATOS SI HAN VUELTO EN LA RESPUESTA
    //
    Plugin.prototype.rePopulateForm = function(){
        var Plugin = this;
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );